module.exports = __webpack_public_path__ + "images/c-fpc-cards.webp";